import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  iconColor = 'var(--color-primary)',
  trend,
  trendDirection,
  onClick
}) => {
  const getTrendColor = () => {
    if (!trendDirection) return 'text-muted-foreground';
    return trendDirection === 'up' ? 'text-success' : 'text-error';
  };

  const getTrendIcon = () => {
    if (!trendDirection) return null;
    return trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  return (
    <div 
      className="bg-card rounded-xl p-4 md:p-6 lg:p-8 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div className="flex-1 min-w-0">
          <h3 className="text-xs md:text-sm font-caption font-medium text-muted-foreground mb-2">
            {title}
          </h3>
          <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
            {value}
          </div>
          {subtitle && (
            <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
          )}
          {trend && (
            <div className={`flex items-center gap-2 mt-2 text-xs md:text-sm font-medium ${getTrendColor()}`}>
              {getTrendIcon() && <Icon name={getTrendIcon()} size={16} color="currentColor" />}
              <span>{trend}</span>
            </div>
          )}
        </div>
        {icon && (
          <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name={icon} size={24} color={iconColor} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;